import React, { useEffect } from 'react';
import {
  OVB_OPPORTUNITIES_WIDGET_NAME,
} from '@utils/constants';
import { useDispatch, useSelector } from 'react-redux';
import { fetchData } from '@store/overviewDashboard/kpiData/actions';
import { MetricTitle } from '@components/overview-dashboard/styled';
import { activeTabSelector } from '@store/overviewDashboard/kpiData/selectors';
import { AdContentTabKey, BenchmarkTabKey } from '@store/overviewDashboard/kpiData/reducer';
import { useHelpPopup } from '@components/overview-dashboard/common/help-popup';
import Content from './Content';
import { MetricWidgetWrapperSub, TitleContainer } from './styled';
import Toggle from './Toggle';
import AdContentTable from './AdContentTable';
import Benchmark from './Benchmark';

const SubOpportunities = () => {
  const dispatch = useDispatch();
  const activeTab = useSelector(activeTabSelector);
  const { helpContext, HelpIcon } = useHelpPopup();

  const renderKPITitle = () => (
    <TitleContainer>
      <MetricTitle style={{ flex: 1 }}>{OVB_OPPORTUNITIES_WIDGET_NAME}</MetricTitle>
      <Toggle />
      <HelpIcon />
    </TitleContainer>
  );

  const renderActiveTab = () => {
    if (activeTab === AdContentTabKey) {
      return (<AdContentTable helpContext={helpContext} retryHandler={retryHandler} />);
    } else if (activeTab === BenchmarkTabKey) {
      return (<Benchmark helpContext={helpContext} retryHandler={retryHandler} />);
    } else {
      return (<Content helpContext={helpContext} retryHandler={retryHandler} />);
    }
  };
  useEffect(() => {
    dispatch(fetchData());
  }, []);

  const retryHandler = () => {
    dispatch(fetchData());
  };

  return (
    <MetricWidgetWrapperSub id="kpi-widget">
      {renderKPITitle()}
      {renderActiveTab()}
    </MetricWidgetWrapperSub>
  );
};

export default React.memo(SubOpportunities);
